import { render, staticRenderFns } from "./BusinessMailbox.vue?vue&type=template&id=b4a4464e&scoped=true&"
import script from "./BusinessMailbox.vue?vue&type=script&lang=js&"
export * from "./BusinessMailbox.vue?vue&type=script&lang=js&"
import style0 from "./BusinessMailbox.vue?vue&type=style&index=0&id=b4a4464e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a4464e",
  null
  
)

export default component.exports